
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Settings } from './../models/settings';
import { List } from 'immutable';
import {asObservable} from "./asObservable";
import { BehaviorSubject } from 'rxjs/Rx';


@Injectable()
export class SettingsService {

  settings: Settings = {
    allowRegistration: true,
    currentCompany:null,
    currentCompanyName: null,
    archiveFolder: null
  }
   public _activeCompany: BehaviorSubject<Settings> = new BehaviorSubject(this.settings);

  constructor() {
    this.getSettings();
   }
   // List les données une fois
  getSettings(){ console.log(' JE SUIS DANS  DE SETTINGS')
    if(localStorage.getItem('settings') !=null){
      let res = localStorage.getItem('settings')
      if (! res.hasOwnProperty('archiveFolder')) {
        console.log('OPA D DE  DD ARCHIVE')
      }
      this._activeCompany.next(JSON.parse(res));
    }
  }

  clear():void{
    localStorage.removeItem('settings');
    this.settings = { allowRegistration: true, currentCompanyName: null, currentCompany: null, archiveFolder: null}
  }
  // observe le comportement et le changement
  getObsSettings(){
    return asObservable( this._activeCompany);
  }
// si l'utilisateur superadmin change ses comportements
 changeSettings(settings: Settings){
    localStorage.setItem('settings', JSON.stringify(settings));
    this.getSettings()
  }
}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/services/settings.service.ts